<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row dense>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium">
            {{ $t('select_security_transfer_type') }}
          </h1>
        </v-col>
        <v-col class="pt-0">
          <ValidationProvider
            :name="$t('transfer_index_type')"
            rules="required"
            v-slot="{ errors }"
          >
            <v-radio-group
              v-model="securityTransfer.transferType"
              :error-messages="errors[0]"
              @change="handleClear"
            >
              <v-radio class="mt-0" value="Receive">
                <template #label>
                  <span class="label primary--text">{{ $t('receive_security') }}</span>
                </template>
              </v-radio>
              <v-radio class="mt-2" value="Send">
                <template #label>
                  <span class="label primary--text">{{ $t('send_security') }}</span>
                </template>
              </v-radio>
              <v-radio class="mt-2" value="Internal">
                <template #label>
                  <span class="label primary--text">{{ $t('internal_security') }}</span>
                </template>
              </v-radio>
            </v-radio-group>
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
export default {
  components: {
    WizardForm
  },
  props: {
    securityTransfer: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClear() {
      this.securityTransfer.securities = []
      this.securityTransfer.beneficiaryName = null
      this.securityTransfer.financialInstitution = null
      this.securityTransfer.accountNumber = null
      this.securityTransfer.supportFile = null
      this.securityTransfer.observations = null
      this.securityTransfer.isThirdParty = false
    }
  }
}
</script>
<style lang="sass" scoped>
.label
  font-size: 1.286rem
</style>
